@if (isEditable) {
  <div class="d-flex align-items-center">
    <input type="checkbox" [checked]="params.value" (change)="onChange($event)" [disabled]="menuService.isReadOnly" />
  </div>
} @else {
  <div>{{ params.value ? BooleanStrings.translatedYes : BooleanStrings.translatedNo }}</div>
}
